module.exports = __webpack_public_path__ + "static/media/md-wifi.f7019f64.svg";